/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserValue { 
    id: string;
    /**
     * the users first and last name
     */
    name: string;
    /**
     * the users email
     */
    email: string;
    /**
     * the users profile color code to display when there is no profile picture
     */
    profileColorCode?: string;
    salutation?: string;
    vacation: boolean;
    outOfOfficeMessage?: string;
}

